import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "input-group" }
const _hoisted_2 = ["rows", "placeholder", "value", "autocomplete", "disabled", "readonly"]
const _hoisted_3 = ["type", "placeholder", "value", "autocomplete", "disabled", "readonly"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppError = _resolveComponent("AppError")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isTextarea)
        ? (_openBlock(), _createElementBlock("textarea", {
            key: 0,
            ref: "textareaRef",
            class: "form-control",
            rows: _ctx.rows,
            placeholder: _ctx.placeholder,
            value: _ctx.modelValue,
            autocomplete: _ctx.autocomplete,
            disabled: _ctx.disabled,
            readonly: _ctx.readonly,
            onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onValueChange && _ctx.onValueChange(...args)))
          }, null, 40, _hoisted_2))
        : (_openBlock(), _createElementBlock("input", {
            key: 1,
            class: "form-control",
            type: _ctx.type,
            placeholder: _ctx.placeholder,
            value: _ctx.modelValue,
            autocomplete: _ctx.autocomplete,
            disabled: _ctx.disabled,
            readonly: _ctx.readonly,
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onValueChange && _ctx.onValueChange(...args)))
          }, null, 40, _hoisted_3))
    ]),
    _createVNode(_component_AppError, { validations: _ctx.validations }, null, 8, ["validations"])
  ]))
}